



















































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
import BannerData from '@/data/BannerData';
import AgentBannerModule from '@/store/modules/AgentBanner';
import GeneralModule from '@/store/modules/General';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import S3 from 'aws-s3';

@Component({
  components: {
    Table,
  },
})
export default class UserOnlineView extends Mixins(ErrorHandleMixin) {
  TableHead = BannerData.TableHead;

  AgentBannerInstance = getModule(AgentBannerModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  config = {
    bucketName: 'image-uploader-amb',
    dirName: 'images',
    region: 'ap-southeast-1',
    accessKeyId: 'AKIAQIRWMGKG54CLGNPW',
    secretAccessKey: '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',
  };

  BannerModel = BannerData.initialModel();

  currentSelection: any = {};

  isOpenRemove = false;

  mode = '';

  file: any = null;

  url: any = null;

  S3Client = new S3(this.config);

  isImage = false;

  searchText = '';

  data = [];

  async created() {
    await this.fetchBanner();
  }

  async fetchBanner() {
    const res = await this.AgentBannerInstance.FetchAgentBanner();
    this.data = this.AgentBannerInstance.list;
    if (res.code) {
      this.checkError(res);
    }
  }

  handleSearch() {
    this.data = this.AgentBannerInstance.list
      .filter((item) => item.description.includes(this.searchText));
  }

  uploadImage(name, files) {
    const [file] = files;
    this.url = URL.createObjectURL(file);
    this.file = file;
    this.isImage = true;
  }

  openModal(index) {
    this.BannerModel = BannerData.initialModel();
    this.url = null;
    this.mode = index > -1 ? 'Update' : 'Create';
    if (index > -1) {
      this.BannerModel = { ...this.AgentBannerInstance.list[index] };
      this.url = this.BannerModel.imagePath;
    }
  }

  async submit() {
    const newFileName = 'img';
    if (this.file) {
      this.GeneralInstance.toggleLoading(true);
      const resS3 = await this.S3Client.uploadFile(this.file, `${newFileName}_${this.file.lastModified}`);
      this.BannerModel.imagePath = resS3.location;
      this.GeneralInstance.toggleLoading(false);
    }
    const res = await this.AgentBannerInstance[`${this.mode}AgentBanner`](this.BannerModel);
    this.checkError(res);
    this.mode = '';
    this.file = '';
    this.fetchBanner();
  }

  remove(item) {
    this.currentSelection = item;
    this.isOpenRemove = true;
  }

  async submitRemove() {
    this.S3Client
      .deleteFile(`img_${this.currentSelection.imagePath.split('img_')[1]}`);
    const res = await this.AgentBannerInstance.DeleteAgentBanner({
      _id: this.currentSelection._id,
    });
    this.checkError(res);
    this.isOpenRemove = false;
    this.fetchBanner();
  }
}
